<template>
    <div class="body">
        <div>

            <div class="mx-auto" id="btn-box">
                <v-btn color="primary" @click="printWithOutHeader()" style="float: left;margin-right: 2px;"> طباعة على النموذج</v-btn>
                <v-btn color="primary" @click="print()" style="float: left;">طباعة</v-btn>
            </div>
            <PrintLetterhead class="header" id="header" />

            <div class="container">
                <h2>شهادة العلاوة السنوية</h2>
                <h3>إدارة الشؤون المالية :-</h3>
                <br>
                <table class="table">
                    <tr>
                        <th>اسم الموظف</th>
                        <th>الدرجة مع العلاوة السابقة</th>
                        <th>تاريخ العلاوة السابقة</th>
                        <th>الدرجة مع العلاوة الحالية</th>
                        <th>تاريخ العلاوة الحالية</th>
                    </tr>
                    <tr>
                        <td>
                            <h5>{{ info.fullName }}</h5>{{ info.administrationName }}
                        </td>
                        <td> <b>
                                {{ info.jobGradeName }} +
                            </b>
                            {{ info.correlatorId - 1 }} ع
                        </td>
                        <td> {{ correlatorDate.toISOString().split('T')[0] }}</td>
                        <td> <b>
                                {{ info.jobGradeName }} +
                            </b>
                            {{ info.correlatorId }} ع
                        </td>
                        <td>{{ info.bonusDate }}</td>
                    </tr>
                </table>
                <div class="content">
                <h3>
                    أشهد بأن الموظف توفرت به شروط الإستحقاق القانونية لهذه العلاوة.
                </h3>
                <div class="date-ref"></div>
                <p>الموافق: <span> {{ new Date().toISOString().split('T')[0] }} م</span></p>
                </div>


                <div class="signature">
                    <p style="margin-left: 6px;"><b> أ.{{ signatureInfo.name }}</b></p>
                    <p><b>رئيس قسم {{ signatureInfo.job }}</b></p>
                </div>
                <br />


                <hr class="dashed">
                <br />
                <div class="content">
                    <h3>
                        إستناداً لأحكام قانون الخدمة العامة أصادق على بيانات العلاوة المبنية أعلاه .
                    </h3>
                    <div class="date-ref">
                        <p>الموافق: <span>{{ new Date().toISOString().split('T')[0] }} م</span></p>
                    </div>
                </div>
                <div class="signature">
                    <p style="margin-left: 10px;"><b>أ . {{ signatureInfo.approvedName }}</b></p>
                    <p><b>مدير {{ signatureInfo.approvedJob }}</b></p>

                </div>
                <br />
                <div>
                    <h6>
                        صـــــــــــــــورة الي
                    </h6>
                    <h6>
                        <img src="@/assets/img/copy-svgrepo-com.svg" alt="صورة" style="width: 9px;">

                        الملف الدوري
                    </h6>
                    <h6>
                        <img src="@/assets/img/copy-svgrepo-com.svg" alt="صورة" style="width: 9px;">

                        المــــــــلف الشخصي
                    </h6>
                    <h6>
                        <img src="@/assets/img/copy-svgrepo-com.svg" alt="صورة" style="width: 9px;">

                        مكتب المـراجعة الداخلية
                    </h6>

                    <hr class="dashedL">
                    <h6>

                        {{ fullName }}
                    </h6>
                </div>

                <PrintFooter class="small footer no-print background" id="footer" />


                
            </div>
        </div>

    </div>
</template>

<script>
export default {
    
    props: {
        correlatorDate: {
            type: Date,
            required: true,
        },
        fullName: {
            type: String,
            required: true,
        },
        info: {
            type: Object,
            required: true,
        },
        signatureInfo: {
            type: Object,
            required: true,
        },
    },
    methods: {
        subtractYears(date, years) {
            date.setFullYear(date.getFullYear() - years);
            return date;
        },
        back() {
            this.$router.back();
        },
        print() {
            document.getElementById("footer").classList.remove("no-print");
            document.getElementById("header").classList.remove("no-print");

            setTimeout(function () {
                window.print();
            }, 500);
        },
        printWithOutHeader() {
            document.getElementById("header").classList.add("no-print");
            document.getElementById("footer").classList.add("no-print");


            setTimeout(function () {
                window.print();
            }, 500);
        },
    },
};
</script>




<style scoped>
@media print {

    

        .no-print {
            visibility: hidden;
        }
    

    /* .footer {
        position: fixed;
        bottom: 10px;
        left: 20px !important;
        right: 20px !important;
        text-align: center;
        border-top: solid 1px;
    } */

    body,
    page[size="A4"] {
        margin: 0;
        box-shadow: 0;
    }

    #btn-box {
        display: none;
        visibility: hidden;
        margin: 0;
        color: rgb(255, 255, 255);
    }

    .body {
        background: #f1f1f1;

        margin: 10px !important;

        box-shadow: 0;
        padding: 5px !important;
    }


    .container {
        padding: 20px 20px !important;
        height: 100% !important;
    }

}

html,
body {
    background: #fff;

}

.header {
    display: flex;
    align-items: center;
    padding: 10px 0px;
    position: relative;
    width: 100%;
    top: 0;
    left: 0;
    border-bottom: 1px solid;
    background-color: #fff;

}

.body {
    background: #fff;

    margin: auto;
    height: 98vh;

    padding: 10mm;
}


.container {
    margin-top: 5px;
    margin-bottom: 20px;
    padding: 20px 2px;
}

/* Date and Reference Styles */
.date-ref {
    display: flex;
    justify-content: space-between;
    font-size: 14px;
    margin-top: 10px;
}

.date-ref p {
    margin: 0;
}

.date-ref span {
    font-weight: bold;
}

/* Content Styles */
h2 {
    font-size: 24px;
    text-align: center;
    margin-top: 20px;
}

.content {
    font-size: 14px;
    line-height: 1.5;
    text-align: right;
}

/* Signature Styles */
.signature {
    margin-top: 60px;
    text-align: left;
    /* Align signature to the right */
    margin-bottom: 20px !important;
}



.signature p {
    margin: 0;
    font-size: 14px;
}

.signature hr {
    border: none;
    border-top: 1px solid black;
    margin: 5px 0;
}

/* Footer Styles */
.footer {
    /* position: absolute;   
  bottom: 10px; */
    background-color: #fff;

    position: fixed !important;
    bottom: 10px !important;
    left: 550px;
    /* Distance from the left */
    /* right: 550px;  */
    left: 20px !important;
    right: 20px !important;
    text-align: center;
    border-top: solid 1px;

}

/* .footer {
        position: fixed;
        bottom: 10px;
        left: 20px !important;
        right: 20px !important;
        text-align: center;
        border-top: solid 1px;
    } */



.v-btn:not(.v-btn--round).v-size--default {
    width: 200px;
    height: 45px;
}

#btn-box {
    text-align: center;
    padding: 10px 10px;
    float: right;
    /* Align text to the right */
}

/* new */

/* table, th, td {
  border: 1px solid black;
  border-collapse: collapse;
}
table{
  float: right;
  display: block;
} */
table {
    border-collapse: collapse;
    width: 100%;
}

td,
th {
    background: #fff;
    border: 1px solid #dddddd;
    text-align: right;
    padding: 8px;
}

tr:nth-child(even) {
    background-color: #dddddd;
}

hr.dashed {
    border-top: 1px dashed #bbb;
    width: auto;
}

hr.dashedL {
    border-top: 1px dashed #bbb;
    width: 150px;
    margin: 8px 1px;
}
</style>